module.exports = __webpack_public_path__ + "static/template_options_week_column_with_task_list-57dde2f2f6c3df707ee87d5f2d51ff5d.png";